<app-banner-app [retroSelected]="true" [Parametros]="this.parametro" [PaginaAnterior]="'InfoImmueble'"
    [IdentLead]="this.leadId" [codAsesor]="this.codAsesor" [bitacoraId]="this.IdBitacora"></app-banner-app>
<br><br>

<!-- Timelines -->
<div class="visibilidadDiv">
    <div class="container" style="width: 700px;">
        <div class="row">
            <div class="col">
                <br><br><br><br>
                <div id="stepper1" class="bs-stepper">
                    <div class="bs-stepper-header" style="text-align: center;">
                        <div class="step" data-target="#test-l-1">
                            <div>
                                <div>
                                    <span class="bs-stepper-circle estiloTextoNum" style="background-color: #00AEC7;">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Arriendo</span>
                            </div>

                        </div>

                        <div class="line" style="height: 2px; margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-2">
                            <div>
                                <span class="bs-stepper-circle estiloTextoNum" style="background-color: #00AEC7;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-check-lg" viewBox="0 0 16 16">
                                        <path
                                            d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                    </svg>
                                </span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Planes</span>
                            </div>
                        </div>

                        <div class="line" style="height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-3">
                            <div>
                                <span class="bs-stepper-circle estiloTextoNum" style="background-color: #00AEC7;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-check-lg" viewBox="0 0 16 16">
                                        <path
                                            d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                    </svg>
                                </span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Datos propietario</span>
                            </div>
                        </div>

                        <div class="line" style="height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-4">
                            <div>
                                <span class="bs-stepper-circle estiloTextoNum" style="background-color: #00AEC7;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-check-lg" viewBox="0 0 16 16">
                                        <path
                                            d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                    </svg>
                                </span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Inmueble</span>
                            </div>
                        </div>

                        <div class="line" style="height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-5">
                            <div>
                                <span class="standby bs-stepper-circle estiloTextoNum"
                                    style="background-color: #2D6DF6;">5</span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Datos inquilino</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br><br>
</div>

<!-- Progress Bar -->
<div class="container contenedorProgressBar">
    <br><br>
    <div class="row">
        <div class="col">
            <strong>
                <p class="progressBarActivo">Datos del inquilino</p>
            </strong>
        </div>
    </div>
    <ngb-progressbar class="mb-3" type="primary" [value]="100" height=".5rem">
    </ngb-progressbar>
</div>

<br>

<div class="container">
    <div class="row">
        <div class="col">
            <div class="textoArriba" style="margin-left: 120px;">
                <div class="aliniacionTexto">
                    <p class="texto1">Ahora, completa los<br>
                        <span class="textoInquilino">datos del inquilino</span>
                    </p>
                </div>
                <div class="aliniacionImagen">
                    <img class="styleImage img-responsive" src="./assets/img/ContratoInquilino.png" />
                </div>
            </div>
            <div class="textoAbajo">
                <div class="aliniacionTextoMobile">
                    <p class="texto1">Ahora, completa los datos del inquilino
                    </p>
                </div>
            </div>
        </div>
        <br>
        <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">
            <main class="form-signin w-100 m-auto">
                <form [formGroup]="formulario">
                    <label for="primerNombre" style="color: #3F3F41;" class="tipoLetra">*Primer nombre</label>

                    <input type="text" #primerNombre required class="form-control tipoLetra estiloPrincipal"
                        formControlName="primerNombre" id="primerNombre" placeholder="Ingresa tu nombre"
                        style="color: #000; height: 48px;"
                        [ngClass]="{ valPrimerNombre2: valPrimerNombre2, valPrimerNombre: valPrimerNombre }"
                        (focusout)="validacionPrimerNombre()">
                    <small *ngIf="nombrePrimerNoValido" class="text-danger tipoLetra">Ingresa tu nombre</small>
                    <br>


                    <label for="numCelular" style="color: #3F3F41;" class="tipoLetra">*Número de celular</label>

                    <input type="number" class="form-control tipoLetra estiloPrincipal" #numCelular
                        formControlName="numCelular" id="numCelular" placeholder="3004263078" required
                        [ngClass]="{ valCelular2: valCelular2, valCelular: valCelular }"
                        (focusout)="validacionCelular()" [ngModel]="" (wheel)="$event.preventDefault()">
                    <small *ngIf="this.valCelular" class="text-danger tipoLetra">
                        Asegúrate de ingresar un número válido de 10 dígitos</small>

                    <small *ngIf="cedularNoValido" class="text-danger tipoLetra">
                        Asegúrate de ingresar un número válido de 10 dígitos</small>
                    <br>

                    <label for="correo" style="color: #3F3F41;" class="tipoLetra">*Correo electrónico</label>

                    <input type="text" class="form-control tipoLetra estiloPrincipal" #correo formControlName="correo"
                        id="correo" placeholder="usuario@correo.com" required
                        [ngClass]="{ valEmail2: valEmail2, valEmail: valEmail }" (focusout)="validacionEmail()"
                        [ngModel]="">
                    <small *ngIf="correoNoValido" class="text-danger tipoLetra">Escribe un correo valido</small>
                    <br>

                    <p class="camposObligatorios">*Los campos son obligatorios</p>
                    <br>
                    <div>
                        <div class="form-check text-start my-8">
                            <input class="form-check-input" type="checkbox" value="remember-me" id="flexCheckAutoriza"
                                name="flexCheckAutoriza" formControlName="flexCheckAutoriza" required>
                            <div class="estiloControlesModel">
                                <a id="autoriza" data-bs-toggle="modal" data-bs-target="#staticBackdrop">El
                                    propietario
                                    autoriza el
                                    tratamiento de sus datos personales a
                                    <strong>Suramericana S.A.</strong>
                                    y garantiza que cuenta con la autorización del tratamiento de datos del
                                    inquilino
                                    para las finalidades
                                    contenidas en la
                                    <strong>política de privacidad</strong>, donde también se encuentran los canales
                                    de
                                    contacto y la
                                    forma de ejercer sus
                                    derechos.
                                </a>
                            </div>
                        </div>
                    </div>

                    <br>


                    <div class="estiloControles">
                        <span class="continua">Al continuar, <strong>aceptas </strong></span>
                        <a class="terminosYCondiciones" data-bs-toggle="modal"
                            data-bs-target="#staticBackdrop2">Términos y
                            condiciones</a>
                    </div>

                    <br><br>

                    <div class="estiloBoton">
                        <button [disabled]="formularioNoValido" class="btn btn-primary w-100 py-2 botonContinuar"
                            (click)="Validaciones()">
                            Continuar
                        </button>
                    </div>
                    <br><br>

                </form>
            </main>
        </div>
    </div>
</div>

<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title terminos-y-condiciones" id="staticBackdropLabel">Autorizaci&oacute;n de los
                    tratamientos de datos</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body texto-terminosYCond">
                <h6>INTRODUCCIÓN</h6>
                <p>Suramericana en desarrollo de sus principios: responsabilidad, respeto, transparencia y equidad,
                    determinan la información de sus empleados, clientes y proveedores como uno de los activos más
                    importantes; por lo tanto, declara la importancia de realizar un adecuado tratamiento de su
                    información, acogiéndose al marco normativo que lo regula en cada uno de los países donde tiene
                    presencia.</p>

                <p><strong>Fecha de entrada en vigencia&ZeroWidthSpace;:</strong><br>
                    1 de noviembre de 2020</p>

                <p><strong>Fecha de actualización&ZeroWidthSpace;:</strong><br>
                    29 de octubre de 2020</p>

                <h6>ALCANCE</h6>

                <p>La presente política de privacidad es un documento vinculante para Suramericana SA en calidad de
                    responsable de los datos a tratar, así como para las filiales, subsidiarias y vinculadas
                    económicamente con Suramericana SA en Colombia y el exterior, que actúan como encargadas del
                    tratamiento de datos, como son: Seguros Generales Suramericana S.A, Seguros de Vida Suramericana
                    S.A, EPS Suramericana S.A., Servicios de salud IPS Suramericana S.A.S., Consultoría en Gestión de
                    Riesgos Suramericana S.A.S, Diagnóstico y Asistencia Médica S.A.S., Operaciones Generales
                    Suramericana S.A.S. Inversiones Suramericana Colombia S.A.S. y Servicios Generales Suramericana
                    S.A.S, entre otras de la región, en adelante LAS
                    COMPAÑÍAS.&ZeroWidthSpace;&ZeroWidthSpace;&ZeroWidthSpace;</p>

                <p>Con el ánimo de garantizar mayor transparencia al Titular y para evitar posibles confusiones, se ha
                    designado a Suramericana S.A. como único responsable del tratamiento ante el cual pueda dirigirse,
                    ya que todas las compañías de Sura Colombia comparten una misma marca.</p>

                <p>Datos del responsable: Suramericana S.A, con domicilio principal en la ciudad de Medellín, en la
                    calle 49B N.º 63-21, piso 1, comunicación a través de la línea de atención al cliente 437 88 88
                    desde Medellín, Bogotá y Cali, o al 01 8000 51 888 en el resto del país, o al correo electrónico
                    protecciondedatos&#64;suramericana.com.co .</p>

                <p><strong>Información que recolectamos y almacenamos de nuestros clientes:</strong> dependiendo de la
                    relación que el titular tenga con LAS COMPAÑÍAS, la información que se recopila o almacena puede
                    incluir lo siguiente:</p>

                <ul>
                    <li><strong>Datos públicos:</strong> es el dato que no sea privado o sensible. Por ejemplo: número y
                        tipo de documento de identidad, información contenida en documentos públicos, estado civil,
                        oficio o profesión, teléfono y correo electrónico corporativos.&ZeroWidthSpace;</li>
                    <li><strong>Datos privados:</strong> son aquellos que por su naturaleza íntima o reservada sólo son
                        relevantes para el titular. Por ejemplo: nivel de ingresos, datos financieros, capacidad de
                        endeudamiento, patrimonio bruto, personas a cargo, composición del grupo familiar, hobbies o
                        aficiones, bienes que posee, información laboral, preferencias en redes sociales, hábitos de
                        conducción, hábitos de consumo, así como datos de contacto como dirección, teléfono y correo
                        electrónico personal.</li>
                    <li><strong>Datos sensibles:</strong> categoría de datos personales que se reducen a la categoría
                        más íntima y sensible de su titular, cuyo tratamiento inadecuado, puede conllevar a la
                        discriminación y/o al sufrimiento de un perjuicio grave y de difícil reparación. Por ejemplo:
                        datos biométricos e historia clínica o datos relacionados con la salud en general.</li>
                </ul>

                <h6>LINEAMIENTOS GENERALES</h6>
                <p><strong>Tratamiento al cual serán sometidos los datos personales:</strong> LAS COMPAÑÍAS usarán la
                    información personal de sus clientes para los fines autorizados e informados al titular y aquellos
                    señalados en la presente política, siempre que el tratamiento obedezca a un fin legítimo y sea
                    proporcional de acuerdo a la vinculación del cliente, particularmente para lo que resulte necesario
                    para la prestación de los servicios encargados, como ejecutar y cumplir el contrato. La autorización
                    de tratamiento de datos sensibles es facultativa.</p>
                <p><strong>Finalidades con las cuales serán tratados los datos:</strong> con el objetivo de obtener un
                    mejor servicio para empleados, clientes o proveedores, autoriza a Suramericana S.A., en calidad de
                    responsable, así como a LAS COMPAÑÍAS, en calidad de encargadas, a tratar sus datos, incluso los
                    biométricos o de salud, que son sensibles, pudiendo o no utilizar computación en la nube, para las
                    siguientes actividades:</p>
                <p><strong>&ZeroWidthSpace;Finalidades inherentes al objeto contractual o autorizadas por
                        normatividad.</strong></p>
                <ol>
                    <li>Compartir información con aliados estratégicos, reaseguradores e intermediarios de seguros para
                        la contratación de productos y servicios, gestión de riesgos, atención de reclamaciones y
                        gestión comercial.</li>
                    <li>Compartir y consultar datos del comportamiento crediticio y financiero con centrales de
                        información y riesgos, aseguradoras y prestadores para prevenir, controlar fraudes y seleccionar
                        riesgos.</li>
                    <li>Consultar y obtener copia de la historia clínica o datos clínicos, que son datos sensibles, con
                        la finalidad de evaluar y suscribir las pólizas, así como gestionar los riesgos que puedan
                        afectar la salud, bienestar y calidad de vida, y el desempeño ocupacional.(*Esta finalidad
                        aplica sólo para el uso de soluciones de salud y vida contratadas con LAS COMPAÑÍAS.)(Esta
                        finalidad aplica sólo para el uso de soluciones de salud y vida contratadas con LAS COMPAÑÍAS).
                    </li>
                    <li>Transmitir y/o transferir datos personales con la finalidad de atraer, valorar, fidelizar,
                        captar y/o estudiar comportamientos del mercado y de atención al cliente; así como para la
                        ejecución de aquellos contratos que sean necesarios para soportar la operación de LAS COMPAÑÍAS
                        y/o el logro de la estrategia corporativa.</li>
                    <li>Prestar el servicio de salud y realizar auditoría de calidad y cuentas médicas, integrando la
                        información clínica disponible en distintos prestadores.(*Esta finalidad aplica sólo para el uso
                        de soluciones de salud y vida contratadas con LAS COMPAÑÍAS.)</li>
                    <li>Realizar investigaciones científicas, comprometiéndose a divulgar los resultados de forma
                        anónima.</li>
                    <li>Tratar los datos para la atención de cualquier reclamación que se efectúe sobre el producto
                        contratado o atención proactiva del mismo, así como para realizar el cobro de primas o aportes
                        adeudados.</li>
                    <li>Compartir información con los prestadores o proveedores autorizados por LAS COMPAÑÍAS, para la
                        coordinación de un servicio o solicitud, con las limitaciones y reglas de la presente política.
                    </li>
                    <li>Facilitar el conocimiento integral y elaboración de propuestas de valor a partir del uso de
                        bases de datos que contengan tanto datos privados como sensibles.</li>
                    <li>Realizar evaluaciones sobre la calidad de los productos y servicios ofrecidos por LAS COMPAÑÍAS
                    </li>
                    <li>Ejercer la defensa de LAS COMPAÑÍAS en procesos judiciales que se adelanten contra ellas.</li>
                </ol>
                <p><strong>Finalidades inherentes al funcionamiento de LAS COMPAÑÍAS</strong></p>
                <ol>
                    <li>Tratar los datos de colaboradores, empleados o aspirantes para efecto de su vinculación con LAS
                        COMPAÑÍAS, el desempeño de sus funciones o la prestación de sus servicios, el retiro o su
                        terminación. Este tratamiento incluye, entre otros: proceso de selección y actividades
                        vinculantes, planes de desarrollo, reconocimiento y pago de beneficios legales y extralegales,
                        comunicaciones internas y externas, procesamiento de información en diferentes aplicativos
                        tecnológicos instalados en servidores de la compañía o en la nube, compensación.</li>
                    <li>Realizar los pagos y afiliaciones al Sistema General de Seguridad Social Integral de los
                        colaboradores.</li>
                    <li>Tratar datos de salud por parte del área de Seguridad y Salud en el Trabajo de LAS COMPAÑÍAS,
                        para prevenir enfermedades o accidentes de origen laboral, y monitorear las actividades propias
                        del Sistema de Gestión de Seguridad y Salud en el Trabajo.</li>
                    <li>Tratar los datos para la vigilancia y seguridad de las personas, los bienes e instalaciones de
                        LAS COMPAÑÍAS, pudiendo desarrollarse a través de captura de imágenes en sistemas de video
                        vigilancia y utilizar dicha información en diferentes procesos y procedimientos laborales y
                        administrativos, tales como, investigación para fraudes, prevención del mismo y/o procesos
                        disciplinarios y sancionatarios.</li>
                </ol>
                <p><strong>Otras finalidades:</strong></p>
                <ol>
                    <li>Entregar o recibir información con entidades como FASECOLDA, INVERFAS, ACEMI u otras, con la
                        finalidad de adelantar actividades y proyectos del sector asegurador y de salud.</li>
                    <li>Ser contactado para la entrega de ofertas comerciales e información publicitaria.</li>
                    <li>Estudiar el comportamiento digital (redes sociales, páginas web, aplicaciones), para realizar
                        una asesoría integral de productos y servicios, y elaborar un perfilamiento de los intereses y
                        hábitos de consumo.</li>
                    <li>Obtener datos sobre la conducción y movilidad para el desarrollo y contratación de productos y
                        servicios, gestión de riesgos, atención de reclamaciones y gestión comercial.</li>
                    <li>Ser contactado para la entrega de información académica, de actualidad normativa, para la
                        prestación de servicios de gestión de la regulación, y para la invitación a eventos y programas
                        académicos patrocinados por LAS COMPAÑIAS o sus aliados estratégicos.</li>
                </ol>
                <p><strong>Derechos de los titulares:</strong> de acuerdo con lo establecido en la Ley 1581 de 2012, los
                    titulares tienen derecho a autorizar el tratamiento de sus datos personales, revocar la
                    autorización, conocer los datos que son tratados, actualizarlos, rectificarlos cuando se considere
                    que existe deficiencia en su calidad, y finalmente solicitar la supresión de datos siempre y cuando
                    no exista una obligación legal o contractual de continuar con el tratamiento (artículo 2.2.2.25.2.8
                    Decreto 1074 de 2015), por ejemplo en el caso de las finalidades que son inherentes al objeto
                    contratado y sin las cuales no es posible su ejecución o las inherentes al funcionamiento de LAS
                    COMPAÑÍAS.</p>
                <p><strong>Ejercicio de los derechos sobre los datos personales:</strong> los titulares de la
                    información podrán ejercer sus derechos en cualquier tiempo, para lo cual podrán comunicarse con la
                    línea de atención al cliente 437 88 88 desde Medellín, Bogotá y Cali, o al 01 8000 51 888 en el
                    resto del país, enviar un correo electrónico a protecciondedatos&#64;suramericana.com.coo establecer
                    contacto con LAS COMPAÑÍAS a través de los distintos medios que estas tienen dispuestos para tal
                    fin, tales como sitio web, redes sociales y oficinas de atención al cliente.</p>
                <p><strong>Principios generales que se acogen para garantizar la protección de los datos personales de
                        los clientes de LAS COMPAÑÍAS:</strong> dentro del compromiso legal y corporativo de LAS
                    COMPAÑÍAS para garantizar la confidencialidad de la información personal de sus clientes, se
                    establecen como principios generales para el tratamiento de la información, en desarrollo de los ya
                    presentes en la Ley 1581 del 2012 y el capítulo 25 del Decreto 1074 de 2015, y demás normas
                    aplicables, los siguientes:</p>
                <ul>
                    <li><strong>Principio de legalidad:</strong> no habrá tratamiento de información personal de los
                        clientes sin observar las reglas establecidas en la normatividad vigente.</li>
                    <li><strong>Principio de finalidad:</strong> la incorporación de datos a las bases físicas o
                        digitales de LAS COMPAÑÍAS deberá obedecer a una finalidad legítima, la cual será oportunamente
                        informada al titular en la cláusula de autorización para el tratamiento y en la política de
                        privacidad.</li>
                    <li><strong>Principio de libertad:</strong> LAS COMPAÑÍAS realizarán tratamiento de datos personales
                        de sus clientes cuando cuenten con la autorización de estos o cuando por norma exista una
                        facultad para hacerlo, en los términos del art. 3° literal a) y 6° literal a) de la Ley 1581 del
                        2012, así como la sección II del capítulo 25 del Decreto 1074 de 2015.</li>
                    <li><strong>Principio de veracidad y calidad:</strong> LAS COMPAÑÍAS propenderán porque la
                        información de sus clientes sea veraz y se encuentre actualizada, para lo cual dispondrá de
                        medios eficientes para la actualización y rectificación de los datos personales.</li>
                    <li><strong>Principio de transparencia:</strong> dentro de los mecanismos que se establezcan para el
                        ejercicio de los derechos de los titulares de la información personal, se garantizará al titular
                        y a sus causahabientes, así como a los terceros autorizados por este, el acceso a la información
                        sobre datos personales que le conciernan.</li>
                    <li><strong>Principio de acceso y circulación restringida:</strong> LAS COMPAÑÍAS se comprometen a
                        garantizar que únicamente personas autorizadas podrán acceder a la información personal.
                        Asimismo, su circulación se limitará al ejercicio de las finalidades autorizadas por el usuario
                        o por la normatividad. LAS COMPAÑÍAS dispondrán de medios contractuales para garantizar la
                        confidencialidad y circulación restringida de la información.</li>
                    <li><strong>Principio de seguridad:</strong> LAS COMPAÑÍAS adelantarán todas las medidas técnicas,
                        administrativas y humanas para garantizar que la información personal de los titulares,
                        almacenada en bases de datos físicas o digitales, no circule o personas no autorizadas accedan a
                        ella.</li>
                    <li><strong>Principio de confidencialidad:</strong> todas las personas que intervengan en el
                        tratamiento de datos personales que no tengan la naturaleza de públicos están obligadas a
                        garantizar la reserva de la información, inclusive después de finalizada su relación con alguna
                        de las labores que comprende el tratamiento, pudiendo sólo realizar suministro o comunicación de
                        datos personales cuando ello corresponda al desarrollo de las actividades autorizadas en la ley
                        y en los términos de la misma.</li>
                </ul>
                <p><strong>Entrega de información personal a proveedores de servicios:</strong> es posible que para
                    cumplir con la relación contractual que LAS COMPAÑÍAS sostengan con el titular de la información,
                    esta sea entregada o compartida con proveedores para las finalidades autorizadas por el titular o
                    las previstas en la ley, tales como ajustadores de siniestros, investigadores, instituciones,
                    profesionales de la salud, call centers, distribuidores y profesionales en prevención,
                    intermediarios de seguros y personas naturales o jurídicas que presten servicios profesionales para
                    efectuar estadísticas, cálculos actuariales, desarrollo de software y cualquier otra actividad para
                    llevar a cabo el objeto social de LAS COMPAÑÍAS y prestar correctamente la atención. Siempre que su
                    información sea entregada o compartida con proveedores, LAS COMPAÑÍAS se asegurarán de establecer
                    unas condiciones que vinculen al proveedor a las políticas de privacidad y seguridad de la
                    información de estas de tal forma que la información personal de los titulares se encuentre
                    protegida. Asimismo, se establecerán acuerdos de confidencialidad para el manejo de la información y
                    obligaciones responsable-encargado cuando el tipo de entrega lo amerite.</p>
                <p><strong>Vigencia del tratamiento de los datos:</strong> la información suministrada por los titulares
                    permanecerá almacenada por el tiempo que sea determinado por el titular o que sea indicado por ley
                    para el cumplimiento de los fines para los cuales fue incorporada.</p>
                <p><strong>Modificaciones a la política de privacidad y tratamiento de datos personales:</strong> LAS
                    COMPAÑÍAS se reservan el derecho de modificar las normas de confidencialidad y protección de datos
                    con el fin de adaptarlas a nuevos requerimientos de tipo legal, jurisprudencial, técnico y, en
                    general, cuando sea necesario para prestar un mejor servicio.</p>
                <p><strong>Aceptación de esta política de privacidad:</strong> el titular de la información acepta el
                    tratamiento de sus datos personales, conforme con los términos de esta política de privacidad,
                    cuando proporciona los datos a través de nuestros canales o puntos de atención y cuando compra,
                    adquiere, se afilia o usa cualquiera de nuestros productos o servicios.&ZeroWidthSpace;</p>

                <h6>GOBERNABILIDAD</h6>

                <p>La aprobación de la presente política está a cargo de la Junta Directiva, o el máximo órgano social,
                    según corresponda, de LAS COMPAÑÍAS y cualquier modificación deberá ser aprobada por estos mismos
                    órganos.</p>
                <p>El oficial de datos de LAS COMPAÑÍAS o quien haga sus veces será la instancia responsable del
                    gobierno y la aplicación de esta política.</p>

                <h6>INSTANCIAS DE DECISIÓN</h6>
                <p>Las instancias de decisión en materia de protección de datos personales estarán bajo las definiciones
                    del oficial de datos de LAS COMPAÑÍAS o quiÉn haga sus veces, el reglamento de trabajo y la
                    normatividad vigente aplicable.</p>

                <h6>DIVULGACIÓN</h6>

                <p>La presente política será vinculante y deberá ser publicada a todos los grupos de interés, dentro de
                    los sitios definidos por LAS COMPAÑÍAS.</p>
                <p>El oficial de datos de LAS COMPAÑÍAS o quién haga sus veces será el responsable de la administración
                    de esta política y en esa medida gestionará con las áreas involucradas su divulgación, cumplimiento
                    y actualización.</p>

            </div>
            <br>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="staticBackdrop2" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel2" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title terminos-y-condiciones" id="staticBackdropLabel2">Términos y Condiciones</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body texto-terminosYCond">
                Suramericana Tech S.A.S., en adelante SURA TECH,
                identificada con NIT. 901641720-3, es una compañía colombiana de servicios,
                con la capacidad técnica, financiera y administrativa para operar tecnologías orientadas a
                habilitar la comercialización y posicionamiento de accesos y canales digitales para la
                industria financiera.<br><br>
                SURA TECH no es una aseguradora, ni un corredor de seguros.
                SURA TECH es una compañía de tecnología que habilita la colocación de seguros digitales
                de las siguientes ASEGURADORAS:<br>
                - Seguros Sura S.A de C.V. – México.<br>
                - Seguros Sura S.A. - El Salvador.<br>
                - Seguros Sura S.A., Seguros de Personas – El Salvador.<br>
                - Seguros Sura S.A. - República Dominicana.<br>
                - Seguros Suramericana S.A. – Panamá.<br>
                - Seguros Generales Suramericana S.A. – Colombia.<br>
                - Seguros de Vida Suramericana S.A. – Colombia.<br>
                - Seguros Sura S.A. – Brasil.<br>
                - Seguros Generales Suramericana S.A. – Chile.<br>
                - Seguros de Vida Suramericana S.A. – Chile.<br>
                - Seguros Sura S.A. – Uruguay.<br>
                - Seguros Sura S.A. - Argentina.<br><br>

                En ese sentido, la relación del contrato de seguro que se genera por el uso de esta
                página web es con la ASEGURADORA directamente y no con SURA TECH.<br><br>

                SURA TECH presta los servicios y habilita la tecnología para colocar los productos de seguros de las
                ASEGURADORAS
                antes señaladas, lo que implica que se está utilizando el canal directo digital de las ASEGURADORAS
                y que SURA TECH no es un intermediario, sino un mero habilitador y prestador de servicios de
                tecnología.<br><br>

                <strong>Definiciones</strong><br>
                ASEGURADORA(S): hace referencia a cualquier compañía o conjunto de
                compañías aseguradoras a las que SURA TECH presta los servicios y habilita la tecnología
                para colocar sus productos:<br><br>
                - Seguros Sura S.A de C.V. – México.<br>
                - Seguros Sura S.A. - El Salvador.<br>
                - Seguros Sura S.A., Seguros de Personas – El Salvador.<br>
                - Seguros Sura S.A. - República Dominicana.<br>
                - Seguros Suramericana S.A. – Panamá.<br>
                - Seguros Generales Suramericana S.A. – Colombia.<br>
                - Seguros de Vida Suramericana S.A. – Colombia.<br>
                - Seguros Sura S.A. – Brasil.<br>
                - Seguros Generales Suramericana S.A. – Chile.<br>
                - Seguros de Vida Suramericana S.A. – Chile.<br>
                - Seguros Sura S.A. – Uruguay.<br>
                - Seguros Sura S.A. - Argentina.<br><br>

                <u>T&C</u>: hace referencia a los presentes Términos y Condiciones en los que se regulan y
                describen los servicios prestados y ofrecidos por SURA TECH al USUARIO.<br>
                <u>USUARIO(S)</u>: hace referencia a cualquier persona natural o jurídica que haga uso de los servicios
                ofrecidos por SURA TECH o haya tenido o tenga acceso parcial o total a los servicios que
                SURA TECH pone a disposición.<br><br>

                <strong>Aceptación</strong><br>
                Al usar esta página web, el USUARIO acepta que
                entiende y está de acuerdo con las condiciones establecidas en los T&C, en la Política de
                privacidad y Tratamiento de datos personales . de la ASEGURADORA, así como en los demás
                documentos incorporados a los mismos por referencia, y da el respectivo consentimiento
                expreso acerca de su compresión y aprobación por el uso del sitio web.<br><br>

                <strong>Modificaciones</strong><br>
                SURA TECH podrá modificar estos T&C en cualquier momento haciendo públicos en esta página web los
                T&C modificados. Todos los T&C modificados entrarán en vigor a los 5 (cinco) días de su publicación.
                Todo usuario que no esté de acuerdo con las modificaciones efectuadas por SURA TECH deberá abstenerse
                de hacer uso de la página web, pues el uso de la página web y/o sus servicios implica la aceptación de
                estos T&C de uso del sitio web.<br><br>

                <strong>Política de manejo de datos personales</strong> <br>
                SURA TECH será la encargada del
                tratamiento de los datos personales del USUARIO. Cada ASEGURADORA con la que se contrate el seguro será
                responsable del tratamiento de los datos personales y en ese sentido, será responsable del uso de la
                información para la finalidad que señale en su respectiva autorización de manejo de datos
                personales.<br><br>

                El USUARIO podrá consultar las Políticas de privacidad y Tratamiento de Datos Personales de la
                ASEGURADORA con la que desea contratar o haya contratado un seguro mediante la página web de la
                ASEGURADORA correspondiente. Con el fin de facilitar la consulta de dichas políticas,
                se pone en conocimiento del USUARIO la página web de las ASEGURADORAS en donde podrá consultar
                dichas políticas:<br>
                - México: https://www.segurossura.com.mx/legales/aviso-de-privacidad/<br>
                - El Salvador: https://www.asesuisa.com/politica-privacidad<br>
                - República Dominicana: https://www.segurossura.com.do/politicas-seguridad-informacion/<br>
                - Panamá:
                https://segurossura.com.pa/wp-content/uploads/2022/04/politica-privacidad-y-tratamiento-de-datos-personales-seguros-sura-panama.pdf<br>
                - Colombia: https://www.segurossura.com.co/paginas/legal/politica-privacidad-datos.aspx<br>
                - Brasil: https://www.segurossura.com.br/politica-privacidade<br>
                - Chile<br>
                - Uruguay<br>
                - Argentina: https://www.segurossura.com.ar/politicas-de-proteccion-de-datos-personales/<br><br>

                Cada ASEGURADORA obtendrá el consentimiento de los titulares previo a consignar cualquier
                dato personal en sus bases de datos. La ASEGURADORA deberá comunicarle al titular de forma clara
                y oportuna, el propósito de uso de sus datos personales, así como los derechos que le asisten
                como titular de estos.<br><br>

                <strong>Servicios</strong> <br>
                Los servicios prestados por SURA TECH consisten en la habilitación
                de una plataforma tecnológica que le permite al USUARIO realizar gestiones relativas la consulta,
                gestión,
                cotización, compra, pago, modificación, solicitud de asistencia, reclamación, renovación, cancelación,
                asesoría o resolución de dudas relativas a los productos digitales de seguros de las ASEGURADORAS.<br>

                Los servicios que SURA TECH ofrece se hacen única y exclusivamente para uso personal y no comercial.
                El USUARIO reconoce y acepta que SURA TECH no rechaza solicitudes en materia de seguros, ni cubre
                directa
                o indirectamente ningún riesgo, ni se encuentra facultada para ello, ni para suscribir o modificar
                pólizas de seguros. SURA TECH facilita y habilita las herramientas tecnológicas para dichas
                gestiones entre el USUARIO y las ASEGURADORAS.<br><br>

                <strong>Cotización</strong> <br>
                Las cotizaciones que SURA TECH facilita
                tienen una vigencia, condiciones y coberturas que pueden variar de una ASEGURADORA a otra.
                SURA TECH no se hace responsable en ningún caso por que las condiciones y coberturas sean iguales entre
                ASEGURADORAS. El período de vigencia de las cotizaciones que SURA TECH facilita al USUARIO podrán
                variar de acuerdo con lo establecido por cada ASEGURADORA.<br>
                El USUARIO acepta y comprende que la entrega
                de una tarifa y condiciones de cotización no implica la aceptación del riesgo por parte de la
                ASEGURADORA ni que SURA TECH garantice que dicha ASEGURADORA está dispuesta a aceptar el riesgo en
                las condiciones establecidas. Las ASEGURADORAS pueden aceptar o rechazar riesgos incluso después de
                haber entregado una cotización. Ni SURA TECH ni la ASEGURADORA tendrán responsabilidad ni obligación
                alguna con el USUARIO en los casos en que la ASEGURADORA rechace la aceptación del riesgo o modifique
                las
                condiciones o tarifas que entregó en su cotización.<br><br>

                <strong>Información de la póliza</strong> <br>
                El USUARIO deberá
                cerciorarse que la información para contratar la póliza y al momento de la emisión de ésta, es correcta,
                exacta, veraz y está actualizada y concuerda con las condiciones y coberturas que es su deseo contratar.
                Al momento de contratar la póliza y en el momento de emisión de la misma el USUARIO deberá validar que
                la
                información que aparece en la carátula de la póliza es correcta, exacta y veraz. En caso de no ser así,
                el USUARIO deberá reportarlo a SURA TECH para subsanar y corregir su información o póliza en la mayor
                brevedad posible. Ni SURA TECH ni las ASEGURADORAS serán responsables de ningún daño, perjuicio o
                pérdida que resulte de la información incorrecta, inexacta o false en las carátulas de las pólizas
                y que el USUARIO así haya reportado en tiempo y forma.<br>
                El USUARIO acepta que las modificaciones que
                se realicen a la póliza o a las condiciones de contratación que modifiquen la clasificación o nivel
                del riesgo del seguro según los criterios de la ASEGURADORA, pueden modificar los montos pagaderos o
                requerir de un pago único del USUARIO a la ASEGURADORA con el fin de cubrir la diferencia entre el
                nuevo monto de las primas y el monto calculado anteriormente.<br><br>

                <strong>Emisión</strong> <br>
                Para la emisión de las pólizas,
                SURA TECH podrá requerir información personal y datos personales (sensibles o no) al USUARIO para
                poder proceder a la contratación de la(s) póliza(s). El USUARIO podrá consultar la Política de
                privacidad y Tratamiento de datos personales de la ASEGURADORA para más información sobre el
                tratamiento de esta información y solicitar cualquier acción sobre su información según los mecanismos,
                formatos y procedimientos establecidos en la misma.<br><br>

                <strong>Pagos</strong> <br>
                El USUARIO reconoce y acepta que cualquier
                cantidad monetaria que se destine para el pago de primas se realiza bajo su autorización expresa o
                que tiene la autorización expresa del propietario del recurso y garantiza que su proveniencia es de
                origen lícito, en los términos establecidos por la legislación vigente. Ni SURA TECH ni las
                ASEGURADORAS se harán responsables en ningún caso y por ningún motivo de cargos realizados a
                tarjetas con datos, documentos o tarjetas robados, hurtados, extraviados o duplicados.<br>

                El USUARIO entiende que el uso de los servicios ofrecidos por SURA TECH puede derivar en cargos o
                cobros en relación con la ASEGURADORA, en una única vez o recurrente, por: (I) los productos que
                contrate con una o varias ASEGURADORAS, (II) modificaciones a las condiciones de los productos
                contratados,
                (III) la declaración de un siniestro cuando las condiciones de la cobertura así lo especifiquen,
                (IV) u otros cargos que establezcan las ASEGURADORAS y que no dependan de SURA TECH.<br>
                La entrega de la carátula de póliza podrá verse afectada por el proceso de cobro de cada ASEGURADORA,
                SURA TECH no podrá modificar dicho proceso y tanto el USUARIO como SURA TECH deberán respetar
                los procedimientos, políticas y condiciones establecidos por cada ASEGURADORA para el pago de sus
                primas.
                SURA TECH no se hará responsable de ningún procedimiento, política o condiciones relativas o
                en relación con los cobros que realiza la ASEGURADORA, aun cuando SURA TECH haya sido informada
                de dicha situación y no haya sido corregida o subsanada.<br><br>

                <strong>Modificaciones</strong> <br>
                En caso de solicitar
                modificaciones a las condiciones de contratación, el USUARIO acepta que la ASEGURADORA podrá
                aplicar cargos adicionales o reducir o aumentar el monto de cargos venideros, según sea el caso.
                Las modificaciones a las condiciones de contratación o endosos se realizan a discreción de la
                ASEGURADORA
                correspondiente y únicamente la ASEGURADORA tiene el derecho más no la obligación de aceptar o rechazar
                dichas solicitudes de modificación o endosos. Ni SURA TECH ni la ASEGURADORA serán responsables de
                ninguna
                solicitud de modificación o endoso rechazado por la ASEGURADORA, ni de ninguna modificación realizada de
                forma errónea, incorrecta o inexacta por la ASEGURADORA o SURA TECH que no haya sido debidamente
                reportada
                por el USUARIO, ni de la afectación, daño, perjuicio o pérdida en que el USUARIO o cualquier tercero
                puedan
                incurrir por una solicitud de modificación o endoso pendiente de ser realizado por la ASEGURADO o por
                SURA TECH.<br><br>

                <strong>Responsabilidad</strong> <br>
                SURA TECH presta los servicios y habilita la tecnología para colocar
                los productos de seguros de las ASEGURADORAS, lo que implica que SURA TECH no asume responsabilidades
                como intermediario, no rechaza solicitudes en materia de seguros, no cubre directa o indirectamente
                ningún riesgo y no se encuentra facultada para hacerlo, no suscribe ni modifica pólizas de seguros.<br>

                La relación de seguro que se genera a partir del uso de la página web o aplicación móvil es directamente
                con la ASEGURADORA y no con SURA TECH.<br>
                SURA TECH facilita y habilita las herramientas tecnológicas para
                facilitar las gestiones antes descritas entre el USUARIO y las ASEGURADORAS.<br><br>

                <strong>Prevención del lavado de activos y financiación del terrorismo</strong> <br>
                El USUARIO declara y garantiza que sus ingresos no provienen de
                actividades ilícitas y que no presentan registros negativos en listados de prevención de lavado de
                activos nacionales o internacionales, ni de financiación del terrorismo, narcotráfico, captación
                ilegal de dinero y en general cualquier actividad ilícita; de igual manera manifiestan que los
                ingresos que se generen durante la vigencia de los presentes T&C no se destinarán a ninguna de
                las actividades anteriormente descritas.<br>
                En consecuencia, será justa causa para dar por terminada
                la relación con el USUARIO, la inclusión de estos, de sus asociados, o de sus representantes en
                los listados de la OFAC, o de cualquier autoridad local o extranjera, como sospechoso de incurrir
                en cualquiera de dichas actividades.<br>
                El USUARIO expresa e irrevocablemente, autoriza a
                SURA TECH y a las ASEGURADORAS (directamente o a través de un tercero), para que consulte los listados,
                sistemas de información y bases de datos a que haya lugar y efectúe los reportes a las autoridades
                competentes en materia de lavado de activos y financiación al terrorismo, que considere necesarios
                para garantizar la prevención y/o administración del riesgo de lavado de activos y financiación al
                terrorismo.<br><br>

                <strong>Contacto y notificaciones</strong> <br>
                SURA TECH podrá realizar notificaciones por
                medio de la página web o la aplicación de los servicios, mediante el correo electrónico y
                teléfono proporcionado por el USUARIO, según el caso.<br><br>

                <strong>Ley aplicable</strong> <br>
                La ley aplicable a los
                presentes T&C será la colombiana en lo relativo a los servicios prestados por SURA TECH.<br><br>

                <strong>Resolución de controversias</strong> <br>
                Cualquier controversia que surja de lo establecido en los presentes
                T&C en lo relativo a los servicios prestados por SURA TECH será resuelta mediante un acercamiento
                amistoso. En caso de no lograrse acuerdo alguno, ambas partes podrán acudir a los tribunales de la
                República de Colombia.<br><br>
            </div>
            <br>
        </div>
    </div>
</div>

<app-footer-app />